<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="row">
    <div class="col-8">
      <label class="form-label">Название файла</label>
      <input placeholder="Название" fullWidth nbInput formControlName="header">
    </div>
    <div class="col-4">
      <label class="form-label">Расширение</label>
      <input readonly nbInput formControlName="fileExt">
    </div>
  </div>
  <nb-card-footer>
    <button nbButton class="button" type="submit" [disabled]="!form.valid"> Сохранить</button>
  </nb-card-footer>
</form>
